import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [SvgIconComponent],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input({ required: true }) currentPage!: number;
  @Input({ required: true }) pageSize!: number;
  @Input({ required: true }) totalItems!: number;
  @Output() pageChanged = new EventEmitter<number>();

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  get pageNumbers(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    const range: (number | string)[] = [];

    if (total === 6) {
      for (let i = 1; i <= 6; i++) {
        range.push(i);
      }
      return range;
    }

    // Directly return all pages if total pages <= 5
    if (total <= 5 || current < 5) {
      for (let i = 1; i <= Math.min(5, total); i++) {
        range.push(i);
      }
      if (total > 6) range.push('...', total);
      return range;
    }

    // General case for pages between 5 and total - 3
    if (current >= 5 && current < total - 2) {
      range.push(1, '...', current - 1, current, current + 1, '...', total);
      return range;
    }

    // Case when we're near the last pages (last 2 pages)
    if (current === total - 2) {
      range.push(1, '...', total - 3, total - 2, total - 1, total);
      return range;
    }

    range.push(1, '...', total - 3, total - 2, total - 1, total);

    return range;
  }

  onPageChange(page: number | string) {
    if (typeof page === 'number' && page !== this.currentPage) {
      this.pageChanged.emit(page);
    }
  }

  trackByFn(index: number, item: number | string): string | number {
    return item;
  }
}
